import React, { Component } from "react";

import "./ConversationListItem.css";
import { RecordVoiceOver } from "@mui/icons-material";
import { Box, Button, Chip, Paper } from "@mui/material";
import Global from "../../customlib/Global";
import { FaRecycle } from "react-icons/fa";

// Konfigurasi chip untuk funnel status
const FUNNEL_CHIP = {
  generated: { label: "GENERATED", color: "warning" },
  viewed: { label: "VIEWED", color: "default" },
  opened: { label: "OPENED", color: "default" },
  interested: { label: "INTERESTED", color: "default" },
  step_1_completed: { label: "STEP 1", color: "primary" },
  step_2_completed: { label: "STEP 2", color: "secondary" },
  payment_pending: { label: "PAYMENT PENDING", color: "error" },
  paid: { label: "PAID", color: "error" },
  ordered: { label: "ORDERED", color: "success" },
};

class ConversationListItem extends Component {
  state = {};

  renderFunnelChip = (funnelStatus) => {
    if (!funnelStatus || funnelStatus.length === 0) return null;
    const cfg = FUNNEL_CHIP[funnelStatus.toLowerCase()];
    if (!cfg) return null;
    return (
      <Box 
        sx={{
          fontWeight: "bold", fontSize: "9px", 
          backgroundColor: "#e4e7e4", pr: "3px", pl: "3px", 
          pt: "1px", pb: "1px", borderRadius: "4px"
        }}>
          Status Subdomain : <span style={{color: "#027a0e", textTransform: "capitalize"}}>{funnelStatus.replaceAll("_", " ")}</span>
        </Box>
      // <Chip
      //   size="small"
      //   label={`Status Subdomain : ${cfg.label}`}
      //   color={"default"}
      //   sx={{ height: "16px", fontSize: "8px", "& .MuiChip-label": { px: "6px" } }}
      // />
    );
  };

  render() {
    const {
      fromName, text, fromNumber, unreadCounter, assignToUserName,
      csHelpState, showButton, firstContactAssignedToName, contactLabel,
      deliveryDate, lastFuResult, crossedPending, isCustomerRecycle,
      salesOnlineFu, funnelStatus,
    } = this.props.data;

    const hasLabel = contactLabel !== undefined && contactLabel !== null && contactLabel.length > 0;
    const hasSalesFu = salesOnlineFu !== undefined && salesOnlineFu !== null && salesOnlineFu.length > 0;
    const hasAssignee = assignToUserName !== undefined && assignToUserName !== null && assignToUserName.length > 0;
    const isPurchasingApp = Global.getAppProfile().type === "PURCHASING-APP";

    return (
      <Paper
        elevation={0}
        className={this.getListItemClasses()}
        onClick={() => { this.props.onSelect(this.props.data); }}
      >
        <div className="cli-row">
          <div className="cli-content">
            {/* Baris 1: nama + funnel status */}
            <div className="cli-line cli-line-top">
              <span className="cli-name">{fromName}</span>
              {/* <span className="cli-meta">{this.renderFunnelChip(funnelStatus)}</span> */}
            </div>

            {/* Baris 2: pesan terakhir + unread badge */}
            <div className="cli-line">
              <span className="cli-snippet">{text}</span>
              {unreadCounter > 0 && <span className="cli-unread">{unreadCounter}</span>}
            </div>

            {/* Baris 3: nomor WhatsApp + label-label */}
            <div className="cli-tags">
              <span className="cli-phone">{Global.maskPhoneNumber(fromNumber)}</span>

              {hasLabel && (
                <>
                  <span className={Global.getLabelClasses(contactLabel)} style={{ fontSize: "10px" }}>{contactLabel}</span>
                  {lastFuResult && <span className={Global.getLabelClasses(contactLabel)} style={{ fontSize: "10px" }}>{lastFuResult}</span>}
                </>
              )}

              <span className="cli-meta">{this.renderFunnelChip(funnelStatus)}</span>

              {hasSalesFu && (
                <Button
                  color={salesOnlineFu === "FU1" ? "error" : salesOnlineFu === "FU2" ? "warning" : "primary"}
                  size="small"
                  variant="outlined"
                  sx={{ fontSize: "10px", py: 0, px: "6px", minWidth: 0, lineHeight: 1.4 }}
                >
                  {salesOnlineFu}
                </Button>
              )}

              {hasAssignee && (
                <span className="cli-assigned">
                  <RecordVoiceOver style={{ width: 13, height: 13 }} /> {assignToUserName}
                </span>
              )}
            </div>

            {/* Tanggal pengiriman (opsional) */}
            {this.props.showDeliveryDate === true && (
              <div className="cli-delivery">
                Pengiriman : {deliveryDate ? Global.formatDateTimeToStrDateTime24(deliveryDate) : "-"}
              </div>
            )}

            {/* Baris bawah: sales pertama + status crossed/recycle */}
            {!isPurchasingApp && (
              <div className="cli-footer">
                <span className="cli-assigned">1'st Sales : {firstContactAssignedToName}</span>
                <span className="cli-footer-right">
                  {crossedPending && <Chip size="small" label="Crossed" color="error" variant="outlined" />}
                  {isCustomerRecycle && <Chip icon={<FaRecycle />} size="small" label="Recycle" color="warning" variant="outlined" />}
                </span>
              </div>
            )}

            {/* Aksi bantuan CS */}
            {showButton === true && csHelpState === "OPEN" && (
              <div className="cli-cs-action">
                <div className="btn btn-primary btn-block" onClick={() => { this.props.onUpdateHelpState("SOLVING"); }}>
                  Bantu Sekarang
                </div>
              </div>
            )}

            {showButton === true && csHelpState === "SOLVING" && (
              <div className="cli-cs-action">
                <div className="btn btn-primary btn-block" onClick={() => { this.props.onUpdateHelpState("SOLVED"); }}>
                  Akhiri Sekarang
                </div>
              </div>
            )}
          </div>
        </div>
      </Paper>
    );
  }

  getListItemClasses() {
    let classes = "conversation-list-item ";
    classes += this.props.data.selected === true ? "selected" : "";
    return classes;
  }
}

export default ConversationListItem;
